module.exports = __webpack_public_path__ + "static/media/captura-de-pantalla-2012-08-22-a-las-10-00-21.0f2b75d6.png";